import { HasFactoryWaterMark, MakeFactory } from '../../../classes/class-helpers/factory';
import { ConstructClassWithPrivateMembers } from '../../../misc/helpers/ClassWithPrivateMembers';
import { ACTIVABLE_PRIVATE, ActivableFactory, IsActivableConstructor } from '../../../misc/activable/implementation';
import { IsObject } from '../../../helpers';
import { NotificationsObservableFactory } from '../../../notifications/core/notifications-observable/implementation';
import { BaseClass } from '../../../classes/class-helpers/base-class';
import { OBSERVABLE_PRIVATE } from '../../../core/observable/privates';
import { ObservableFactory } from '../../../core/observable/implementation';
import { IsNotificationsObservableConstructor } from '../../../notifications/core/notifications-observable/constructor';
export const INPUT_OUTPUT_PRIVATE = Symbol('input-output-private');
export function ConstructInputOutput(instance, observable, observer) {
    ConstructClassWithPrivateMembers(instance, INPUT_OUTPUT_PRIVATE);
    instance[INPUT_OUTPUT_PRIVATE].in = observable;
    instance[INPUT_OUTPUT_PRIVATE].out = observer;
}
export function IsInputOutput(value) {
    return IsObject(value)
        && value.hasOwnProperty(INPUT_OUTPUT_PRIVATE);
}
const IS_INPUT_OUTPUT_CONSTRUCTOR = Symbol('is-input-output-constructor');
export function IsInputOutputConstructor(value, direct) {
    return (typeof value === 'function')
        && HasFactoryWaterMark(value, IS_INPUT_OUTPUT_CONSTRUCTOR, direct);
}
function PureInputOutputFactory(superClass) {
    if (!IsNotificationsObservableConstructor(superClass, false)) {
        throw new TypeError(`Expected NotificationsObservables' constructor as superClass`);
    }
    if (!IsActivableConstructor(superClass, false)) {
        throw new TypeError(`Expected Activable's constructor as superClass`);
    }
    return class InputOutput extends superClass {
        constructor(...args) {
            const [observable, observer] = args[0];
            super(...args.slice(1));
            ConstructInputOutput(this, observable, observer);
        }
        get in() {
            return this[INPUT_OUTPUT_PRIVATE].in;
        }
        get out() {
            return this[INPUT_OUTPUT_PRIVATE].out;
        }
    };
}
export let InputOutput;
export function InputOutputFactory(superClass) {
    return MakeFactory(PureInputOutputFactory, [], superClass, {
        name: 'InputOutput',
        instanceOf: InputOutput,
        waterMarks: [IS_INPUT_OUTPUT_CONSTRUCTOR],
    });
}
export function InputOutputBaseFactory(superClass) {
    return MakeFactory(PureInputOutputFactory, [ActivableFactory, NotificationsObservableFactory, ObservableFactory], superClass, {
        name: 'InputOutput',
        instanceOf: InputOutput,
        waterMarks: [IS_INPUT_OUTPUT_CONSTRUCTOR],
    });
}
export function InputOutputBaseOptionsForSuper(options) {
    return [
        [
            options.observable,
            options.observer
        ], [{
                activate: options.activate,
                deactivate: options.deactivate,
            }], [
            options.create
        ],
        []
    ];
}
InputOutput = class InputOutput extends InputOutputBaseFactory(BaseClass) {
    constructor(options) {
        super(...InputOutputBaseOptionsForSuper(options));
    }
};
//# sourceMappingURL=implementation.js.map